module.exports = __webpack_public_path__ + "img/40.446b5d83.png";